export const cookies = {
    set: (name, value, options = {}) => {
        const {
            expires,
            path = '/',
            domain,
            secure = true,
            sameSite = 'strict',
            httpOnly = false
        } = options;
        let cookieString = `${name}=${encodeURIComponent(value)}`;
        if (expires) cookieString += `; expires=${expires.toUTCString()}`;
        if (path) cookieString += `; path=${path}`;
        if (domain) cookieString += `; domain=${domain}`;
        if (secure) cookieString += '; secure';
        if (sameSite) cookieString += `; samesite=${sameSite}`;
        document.cookie = cookieString;
    },
    get: (name) => {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    },
    delete: (name, options = {}) => {
        const { path = '/', domain } = options;
        const expires = new Date(0);
        let cookieString = `${name}=; expires=${expires.toUTCString()}; path=${path}`;
        if (domain) cookieString += `; domain=${domain}`;
        document.cookie = cookieString;
        console.log('[cookies] Delete cookie:', name, 'cookieString:', cookieString);
    },
    exists: (name) => {
        const exists = cookies.get(name) !== null;
        console.log('[cookies] Exists cookie:', name, exists);
        return exists;
    }
};

export const authCookies = {
    setIdToken: (token) => { cookies.set('id_token', token); },
    setAccessToken: (token) => { cookies.set('access_token', token); },
    setRefreshToken: (token) => { cookies.set('refresh_token', token); },
    getIdToken: () => cookies.get('id_token'),
    getAccessToken: () => cookies.get('access_token'),
    getRefreshToken: () => cookies.get('refresh_token'),
    clearTokens: () => {
        cookies.delete('id_token');
        cookies.delete('access_token');
        cookies.delete('refresh_token');
    },
    isAuthenticated: () => !!cookies.get('id_token')
}; 